// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.consent-form-module__consent-text___ttw6Z {
  margin-bottom: 24px;
}
.consent-form-module__consent-text___ttw6Z h1 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 24px;
}
.consent-form-module__consent-text___ttw6Z h2,
.consent-form-module__consent-text___ttw6Z h3,
.consent-form-module__consent-text___ttw6Z h4,
.consent-form-module__consent-text___ttw6Z h5 {
  margin-bottom: 12px;
}
.consent-form-module__consent-text___ttw6Z p,
.consent-form-module__consent-text___ttw6Z ul,
.consent-form-module__consent-text___ttw6Z ol,
.consent-form-module__consent-text___ttw6Z a,
.consent-form-module__consent-text___ttw6Z strong {
  font-size: 0.875rem;
  line-height: 1.25;
}
.consent-form-module__consent-text___ttw6Z ul li {
  list-style: disc;
}
.consent-form-module__consent-text___ttw6Z ol li {
  list-style: decimal;
}
.consent-form-module__consent-text___ttw6Z ul,
.consent-form-module__consent-text___ttw6Z ol {
  padding-inline-start: 40px;
}
.consent-form-module__consent-text___ttw6Z p {
  margin-bottom: 24px;
}
.consent-form-module__consent-text___ttw6Z a {
  color: var(--primary600, #4b286d);
  text-decoration: underline;
  margin-bottom: 24px;
}

.consent-form-module__footer__item___wYBrV {
  margin-bottom: 24px;
  padding-top: 1px;
}

.consent-form-module__continue-button___iPtbd {
  margin-top: 32px;
}
.consent-form-module__continue-button__button-wrapper___JaOK6 {
  display: block;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/consent-form/consent-form.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,mBAAA;AAMF;AAJE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAMJ;AAHE;;;;EAIE,mBAAA;AAKJ;AAFE;;;;;EAKE,mBAAA;EACA,iBAAA;AAIJ;AADE;EACE,gBAAA;AAGJ;AAAE;EACE,mBAAA;AAEJ;AACE;;EAEE,0BAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,iCAAA;EACA,0BAAA;EACA,mBAAA;AADJ;;AAME;EACE,mBAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;AAME;EACE,cAAA;AAJJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"consent-text": `consent-form-module__consent-text___ttw6Z`,
	"footer__item": `consent-form-module__footer__item___wYBrV`,
	"continue-button": `consent-form-module__continue-button___iPtbd`,
	"continue-button__button-wrapper": `consent-form-module__continue-button__button-wrapper___JaOK6`
};
export default ___CSS_LOADER_EXPORT___;
